module.exports = __webpack_public_path__ + "static/media/order.095e5c45.png";